import * as lscache from "lscache";

export const SUBSCRIPTION_KEY = "subscription";

export const getSubscriptionStatus = () => lscache.get(SUBSCRIPTION_KEY);
